import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const options = {
  name: 'widgetArchetypes',
  baseType: 'WIDGET_ARCHETYPES',
  apiEndpoint: 'dashboards/widget_archetypes'
};

const operations = createMetadataAPIOperations(options);
const selectors = createMetadataAPISelectors(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
